import { View } from 'react-native';

import { BrandMark } from '@/components/ui/BrandMark';

import { Body } from './Body';
import { Eyebrow } from './Eyebrow';
import { FooterColumn } from './FooterColumn';
import { Section } from './Section';

export function LandingFooter() {
  return (
    <Section className="border-t border-border-strong py-14">
      <View className="flex-col justify-between gap-8 sm:flex-row">
        <View className="max-w-[300px] gap-3.5">
          <BrandMark size="md" />
          <Body className="text-sm leading-[1.6] text-muted">
            Make your life repeatable.
          </Body>
        </View>
        <View className="flex-row flex-wrap gap-x-14 gap-y-10">
          <FooterColumn
            title="Company"
            links={[{ label: 'About' }, { label: 'Contact' }, { label: 'Changelog' }]}
          />
          <FooterColumn
            title="Legal"
            links={[{ label: 'Privacy' }, { label: 'Terms' }]}
          />
        </View>
      </View>
      <View className="mt-9 border-t border-border-strong pt-5">
        <Eyebrow className="text-[11px] tracking-[0.08em] text-faint">
          © Straw Dynamics LLC
        </Eyebrow>
      </View>
    </Section>
  );
}
